import router from '@/router'
import { defaultState } from './state'

const actions = {
	skip ({ commit, state }) {
		let { forward, step } = state
		if (forward) {
			step++
		} else {
			step--
		}

		commit('setStep', step)
	},
	setStep ({ commit, state, rootState }, step) {
		if (4 < step && !rootState.apiKey) {
			// Sorry, no dice.
			return false
		}

		commit('setStep', step)
	},
	maybeGoBack ({ dispatch, state, rootState }) {
		if (!rootState.apiKey && 4 < state.step) {
			dispatch('setStep', 4)
		}
	},
	exit ({ dispatch, rootState }, to) {
		if (rootState.apiKey) {
			dispatch('complete')
		}

		if ('previous' === to) {
			to = router.getPreviousRoute()
		}

		let dest
		if (to.name) {
			const route = router.matcher.match(to)
			dest = (route.fullPath || route.path)
		}

		// Not using router because we want a fresh state fetch for user.
		window.location.href = dest || '?page=optin-monster-dashboard'
	},
	complete ({ commit, dispatch, state, getters }) {
		if (!getters.proFeatures || !getters.proFeatures.length || state.complete) {
			return
		}

		const url = features => this._vm.$urls.upgrade({ utm_medium: 'WizardFollowUpNotification' }, features)

		const titles = getters.proFeatures.map(f => {
			return `<a href="${url(f.slug)}" target="_blank" rel="noopener">${f.title}</a>`
		})

		const notice = {
			type    : 'action',
			title   : 'Action required!',
			content : `To receive the requested features (${titles.join(', ')}), you will need to upgrade to Pro.`,
			btns    : {
				main : {
					text : 'Upgrade Now & Save 35%',
					url  : url(getters.proFeatures.map(f => f.slug)),
				},
			},
		}
		dispatch('notifications/maybeCreate', notice, { root: true })
		commit('complete')
	},
	resetState ({ commit, state }) {
		commit('resetState', defaultState())
	},
}

export default actions
